import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RightCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/RightCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var RightCircleTwoTone = function RightCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RightCircleTwoTone.displayName = 'RightCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(RightCircleTwoTone);